import Papa from 'papaparse'

import { Component, EventEmitter, Output, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend'
import { Library } from '../../services/ShelvableBackend/Library'
import { Shelf } from '../../services/ShelvableBackend/Shelf'
import { Utilities } from '../../services/Utilities'
import { GoogleData } from '../../services/GoogleData/GoogleData'
import { NgbModal, NgbModalRef } from '@mattlewis92/ng-bootstrap';
import { ImportFinderComponent } from '../import-finder/import-finder'
import { Analytics } from '../../services/Analytics'
import swal from 'sweetalert';

import { Observable, BehaviorSubject, Subscription } from 'rxjs'

@Component({
    selector: 'importer',
    templateUrl: './importer.html',
    styleUrls: ['./importer.css'],
    encapsulation: ViewEncapsulation.None

})
export class ImporterComponent implements OnDestroy {
    
    @Output() onImportReady:EventEmitter<{doImport: () => void}> = new EventEmitter<{doImport: () => void}>();
    @Output() onImportErrors:EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onImportComplete:EventEmitter<void> = new EventEmitter<void>();

    loggedInUserShelves:Observable<Shelf[]>
    spellOutNumber:(num:number) => string;

    username:Observable<string>;

    makeArrayOfLength:(length:number) => any[] = Utilities.makeArrayOfLength;

    constructor(private shelvableBackend:ShelvableBackend, private googleData:GoogleData, private modalService:NgbModal) {
        this.loggedInUserShelves = shelvableBackend.loggedInUserShelves;
        
        this.spellOutNumber = Utilities.spellOutNumber;
        this.username = shelvableBackend.loggedInUserObs.usernameObs;
    }

    importStatus = {
        complete: false,
        ready: false,
        setErrors: (hasErrors:boolean) => {
            this.onImportErrors.emit(hasErrors);
        }
    }

    private normaliseKeys(obj:any):any {
        var newObj = {};
        for (var key in obj) {
            newObj[key.trim().toLowerCase()] = obj[key]; 
        }
        return newObj;
    };
    
    originalBookData:{[isbn:string]:any};
    private normaliseData(data:any[]):{[shelfName:string]:any} {
        var shelves = {};
        this.originalBookData = {}
        
        data.forEach((line) => {
            var normalLine = this.normaliseKeys(line);
            
            if (normalLine.isbn) {
                var isbn = normalLine.isbn;
                this.originalBookData[isbn] = line;
                if (normalLine.bookshelves) {
                    var bookshelves = normalLine.bookshelves.split(' ');
                    bookshelves.forEach((shelf) => {
                        if (shelf === "") return;
                        
                        if (!shelves[shelf]) {
                            shelves[shelf] = [isbn];
                        } else {
                            shelves[shelf].push(isbn);
                        }
                    });
                }
            }
        });
        return shelves;
    };

    parseComplete:boolean = false;
    booksNotFound:Observable<number>;
    completedBooks:Observable<number>;

    processedData:ProcessedShelf[] = null;
    
    totalBooks:number = null;

    parsedShelves:{[shelfName:string]:any};

    errorsSubscription:Subscription;

    async processData() {
        if (this.errorsSubscription) {
            this.errorsSubscription.unsubscribe();
            this.errorsSubscription = null;
        }

        Analytics.importer('process');
        
        this.processedData = [];
        
        var promises:Promise<string>[] = [];
        
        this.totalBooks = 0;  
        for (var shelfName in this.parsedShelves) {
            this.totalBooks += this.parsedShelves[shelfName].length;
        }
        
        for (var shelfName in this.parsedShelves) {
            var isbns = this.parsedShelves[shelfName].map((isbn) => {return {isbn:isbn, originalData: this.originalBookData[isbn]}});

            var processedShelf = new ProcessedShelf(this.shelvableBackend, shelfName, isbns, this.googleData);
            
            this.processedData.push(processedShelf);
        }

        // this observable tracks whether any processed shelves have import=true and isValid=false
        var anyAreInvalid = Observable.combineLatest(this.processedData.map((s) => Observable.combineLatest(s.import, s.shelfValidity).map(([shouldImport, validity]) => shouldImport && !validity.isValid))).map((hasErrors) => hasErrors.some((e) => e));
        this.errorsSubscription = anyAreInvalid.subscribe(this.importStatus.setErrors);

        var allBooks = this.processedData.map((shelf) => shelf.books).reduce((a, b) => a.concat(b), []);
        this.booksNotFound = Observable.combineLatest(allBooks.map((book) => book.notFound)).map((notFounds) => notFounds.filter(b => b).length).shareReplay(1);
        this.completedBooks = Observable.combineLatest(allBooks.map((book) => book.isLoading)).map((isLoadings) => isLoadings.filter(b => !b).length).shareReplay(1);

        await Promise.all(allBooks.map(book => book.promise));
        this.onImportReady.emit({doImport: () => this.doImport()});
        this.importStatus.ready = true;
        
    };

    async shelfExists(shelfName:string) {
        return (await this.loggedInUserShelves.take(1).toPromise()).some((shelf) => shelf.shelfName === shelfName);
    }

    async doImport() {
        Analytics.importer('import');
        
        var shelvesToImport = {};
        for (var shelf of this.processedData) {
            if (shelf.import.getValue()) {
                var name = shelf.newName.getValue() || shelf.shelfName;
                shelvesToImport[name] = shelf.books;
            }
        }
        
        try {
            await this.shelvableBackend.importShelves(shelvesToImport); 
            this.importStatus.complete = true;
            this.onImportComplete.emit();
        } catch (err) {
            console.error(err);
            swal("There was an error importing your shelves.", "Sorry about that.", "error");
        };
        
    }

    ngOnDestroy() {
        if (this.findBookModal) {
            this.findBookModal.dismiss();
        }
    }

    private findBookModal:NgbModalRef = null;
    async showFindBookModal(book:BookData) {
        Analytics.importer('findBook');
        
        this.findBookModal = this.modalService.open(ImportFinderComponent);

        this.findBookModal.componentInstance.bookData = book.originalData;
        
        try {
            var result = await this.findBookModal.result
            Analytics.importer('foundbook');
            
            if (result && result.$value) {
                book.foundBook();
                book.promise = Promise.resolve(result.$value);
                book.highlight = true;
                setTimeout(() => {
                    book.highlight = false;
                }, 3000);
            }
        } catch (err) {
            console.log('Find book modal closed.')
        };
        Utilities.reAddModalOpen();
    };

    alreadyExistsMessage = 'A shelf with this name already exists. If you keep this name, the books will be added to the existing shelf.';


    onFileSelected(file:File) {
        if (!file) return;
        
        Analytics.importer('loadData');
        
        Papa.parse(file, {
            header: true, 
            complete: (result) => {
                this.parsedShelves = this.normaliseData(result.data);
                this.parseComplete = true;
            }
        });

    }

}

class ProcessedShelf {
    constructor(shelvableBackend:ShelvableBackend, public shelfName:string, isbns:{isbn:string, originalData:any}[], private googleData:GoogleData) {
        this.newName = new BehaviorSubject<string>(shelfName);
        this.shelfValidity = this.newName.flatMap((name) => shelvableBackend.validateShelfName(name, true));
        this.shelfExists = this.newName.flatMap((name) => shelvableBackend.loggedInUserShelves.map((shelves) => shelves.some((shelf) => shelf.shelfName === name)));
        this.books = isbns.map((entry) => {
            var isLoading = new BehaviorSubject<boolean>(true);

            var notFound = new BehaviorSubject<boolean>(false);

            var promise = (async () => {
                try {
                    var googleId = await this.googleData.getGoogleIdFromISBN(entry.isbn.trim());
                    isLoading.next(false);
                    if (googleId === null) {
                        notFound.next(true);
                    }
                    return googleId;
                } catch (err) {
                    console.error(err);
                    notFound.next(true);
                    isLoading.next(false);
                    return null;
                }
            })();

            
            return {
                originalData: entry.originalData,
                promise: promise,
                isLoading: isLoading.asObservable(),
                notFound: notFound.asObservable(),
                foundBook: () => {notFound.next(false)},
                highlight: false
            };
        });
        
    } 



    public books:BookData[];

    newName:BehaviorSubject<string>;
    import:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    
    shelfValidity:Observable<{message?:string, isValid:boolean}>
    shelfExists:Observable<boolean>;
}

export type BookData = {
    originalData:any, 
    promise:Promise<string>, 
    isLoading:Observable<boolean>, 
    notFound:Observable<boolean>,
    foundBook: () => void,
    highlight:boolean
}



// WEBPACK FOOTER //
// ./web/static/components/importer/importer.ts